/**
 * Generated file, do not edit directly!
 */

/** Borders provide style, width, and radius to the edges of an element. */

const Style = {
  /**
   * Use as the default border style.
   * Css custom property: --dt-borders-style-default. Default value: solid.
   */
  Default: 'var(--dt-borders-style-default, solid)',
  /**
   * Use to indicate interactive text.
   * Css custom property: --dt-borders-style-dashed. Default value: dashed.
   */
  Dashed: 'var(--dt-borders-style-dashed, dashed)',
};
const Width = {
  /**
   * Use as the default border width.
   * Css custom property: --dt-borders-width-default. Default value: 1px.
   */
  Default: 'var(--dt-borders-width-default, 1px)',
  /**
   * Use to emphasize borders. This can be useful to clearly separate content.
   * Css custom property: --dt-borders-width-emphasized. Default value: 2px.
   */
  Emphasized: 'var(--dt-borders-width-emphasized, 2px)',
};
const Radius = {
  Surface: {
    /**
     * Use as the subdued border radius for surfaces.
     * Css custom property: --dt-borders-radius-surface-subdued. Default value: 9px.
     */
    Subdued: 'var(--dt-borders-radius-surface-subdued, 9px)',
    /**
     * Use as the default border radius for surfaces.
     * Css custom property: --dt-borders-radius-surface-default. Default value: 12px.
     */
    Default: 'var(--dt-borders-radius-surface-default, 12px)',
  },
  Container: {
    /**
     * Use as the subdued border radius for containers.
     * Css custom property: --dt-borders-radius-container-subdued. Default value: 6px.
     */
    Subdued: 'var(--dt-borders-radius-container-subdued, 6px)',
    /**
     * Use as the default border radius for containers.
     * Css custom property: --dt-borders-radius-container-default. Default value: 9px.
     */
    Default: 'var(--dt-borders-radius-container-default, 9px)',
  },
  Field: {
    /**
     * Use as the subdued border radius for fields.
     * Css custom property: --dt-borders-radius-field-subdued. Default value: 3px.
     */
    Subdued: 'var(--dt-borders-radius-field-subdued, 3px)',
    /**
     * Use as the default border radius for fields.
     * Css custom property: --dt-borders-radius-field-default. Default value: 6px.
     */
    Default: 'var(--dt-borders-radius-field-default, 6px)',
    /**
     * Use for rounded or pill-like shapes.
     * Css custom property: --dt-borders-radius-field-emphasized. Default value: 9999px.
     */
    Emphasized: 'var(--dt-borders-radius-field-emphasized, 9999px)',
  },
};
export default {
  Style,
  Width,
  Radius,
};
